export const HDALU_TREATMENTS = ["HD Aluminum Panel", "HD Aluminum in Floater"];

export const HDALU_FINISHES = [
  {
    label: "Glossy White Finish",
    url: "/content/papers/hdalu/glossy-white.webp",
    description:
      "The white gloss finish offers a brilliant shine, producing HD Aluminum prints with maximum saturation and clarity.",
  },
  {
    label: "Matte White Finish",
    url: "/content/papers/hdalu/matte-white.webp",
    description:
      "A white matte finish gives your photo amazing definition with a softly luminous quality and minimal glare. Has slightly less depth of saturated color when compared to our white glossy surface.",
  },
  {
    label: "Glossy Silver Finish",
    url: "/content/papers/hdalu/glossy-silver.webp",
    description:
      "The silver gloss finish maximizes the metallic effect of our HD Aluminum prints.  By turning the white points silver, this option produces highly stylized luminous prints. Perfect for high contrast images. Note that because the silver finishes lack a true white point ,the color rendering can be unpredictable and some colors may appear dull.",
  },
  {
    label: "Matte Silver Finish",
    url: "/content/papers/hdalu/matte-silver.webp",
    description:
      "Our silver matte aluminum surface adds an intriguing semi-transparent feel to the colors, emulating the look of printing directly on the metal. Note that because the silver finishes lack a true white point, the color rendering can be unpredictable and some colors may appear dull.",
  },
];

export const HDALU_FRAME_TYPES = [
  {
    dimensions: {
      depth: 1.125,
      face: 0.75,
    },
    label: "Black Floater Frame",
    texture: {
      face: "black",
      hex: "#333333",
      preview: "black",
      side: "black",
    },
    description: {
      "in-floater-frame":
        'Solid wood, matte black finish. 7/16" face, 2" deep from wall.',
    },
    url: "/content/frames/canvas-hdalu/black-floater.png",
  },
  {
    dimensions: {
      depth: 1.125,
      face: 0.75,
    },
    label: "White Floater Frame",
    texture: {
      face: "white",
      hex: "#fffffe",
      preview: "white",
      side: "white",
    },
    description: {
      "in-floater-frame":
        'Solid wood, matte white finish. 7/16" face, 2" deep from wall.',
    },
    url: "/content/frames/canvas-hdalu/white-floater.png",
  },
  {
    dimensions: {
      depth: 1.4375,
      face: 0.75,
    },
    label: "Weathered Walnut Floater Frame",
    texture: {
      face: "weathered",
      hex: "",
      preview: "weathered",
      side: "weathered",
    },
    description: {
      "in-floater-frame":
        'Solid wood, slightly distressed warm walnut finish with visible wood grain. 7/16" face, 2" deep from wall.',
    },
    url: "/content/frames/canvas-hdalu/weathered-walnut-floater.png",
  },
  {
    dimensions: {
      depth: 1.4375,
      face: 0.75,
    },
    label: "Weathered Gray Floater Frame",
    texture: {
      face: "weathered",
      hex: "",
      preview: "weathered",
      side: "weathered",
    },
    description: {
      "in-floater-frame":
        'Solid wood, slightly distressed rich black finish with visible wood grain. 7/16" face, 2" deep from wall.',
    },
    url: "/content/frames/canvas-hdalu/weathered-gray-floater.png",
  },
  {
    dimensions: {
      depth: 1.4375,
      face: 0.75,
    },
    label: "Weathered Black Floater Frame",
    texture: {
      face: "weathered",
      hex: "",
      preview: "weathered",
      side: "weathered",
    },
    description: {
      "in-floater-frame":
        'Solid wood, slightly distressed rich black finish with visible wood grain. 7/16" face, 2" deep from wall.',
    },
    url: "/content/frames/canvas-hdalu/weathered-black-floater.png",
  },
  {
    dimensions: {
      depth: 1.4375,
      face: 0.75,
    },
    label: "Weathered White Floater Frame",
    texture: {
      face: "weathered",
      hex: "",
      preview: "weathered",
      side: "weathered",
    },
    description: {
      "in-floater-frame":
        'Solid wood, slightly distressed white finish with visible wood grain. 7/16" face, 2" deep from wall.',
    },
    url: "/content/frames/canvas-hdalu/weathered-white-floater.png",
  },
  {
    dimensions: {
      depth: 1.4375,
      face: 0.75,
    },
    label: "Dark Walnut Floater Frame",
    texture: {
      face: "weathered",
      hex: "",
      preview: "weathered",
      side: "weathered",
    },
    description: {
      "in-floater-frame":
        'Solid wood, rich dark walnut finish with visible wood grain. 7/16" face, 1-7/8" deep from wall.',
    },
    url: "/content/frames/canvas-hdalu/dark-walnut-floater.png",
  },
  {
    dimensions: {
      depth: 1.125,
      face: 0.75,
    },
    label: "Gold Floater Frame",
    texture: {
      face: "metallic",
      hex: "#000000",
      preview: "metallic",
      side: "metallic",
    },
    description: {
      "in-floater-frame":
        'Solid wood, metallic gold finish. 7/16" face, 1-7/8" deep from wall.',
    },
    url: "/content/frames/canvas-hdalu/gold-floater.png",
  },
  {
    dimensions: {
      depth: 1.125,
      face: 0.75,
    },
    label: "Silver Floater Frame",
    texture: {
      face: "metallic",
      hex: "#000000",
      preview: "metallic",
      side: "metallic",
    },
    description: {
      "in-floater-frame":
        'Solid wood, metallic silver finish. 7/16" face, 1-7/8" deep from wall.',
    },
    url: "/content/frames/canvas-hdalu/silver-floater.png",
  },
];
